import React from 'react';
import Header from '../components/header/HeaderThree';
import Footer from '../components/footer/FooterOne';

import Hero from '../components/sections/HeroOne';
import BrandOne from '../components/sections/BrandOne';
import AboutOne from '../components/sections/AboutOne';
import ServiceSecOne from '../components/sections/ServiceSecOne';
import ProjectSecOne from '../components/sections/ProjectSecOne';
import WhySecOne from '../components/sections/WhySecOne';
import CounterSecOne from '../components/sections/CounterSecOne';
import TeamSecOne from '../components/sections/TeamSecOne';
import TestimonialSecOne from '../components/sections/TestimonialSecOne';
import PriceSecOne from '../components/sections/PriceSecOne';
import FaqSecTwo from '../components/sections/FaqSecTwo';
import ContactSecOne from '../components/sections/ContactSecOne';
import BlogSecOne from '../components/sections/BlogSecOne';

const HomeOne = () => {
  return (
    <>
      <Header />
      <div className="home-page">
        <Hero />
        <BrandOne className="bg-smoke pt-60 pb-60" />
        <AboutOne />
        <ServiceSecOne className="overflow-hidden space-bottom" />
        <ProjectSecOne className="space overflow-hidden bg-smoke" />
        <WhySecOne className="space overflow-hidden" /> 
        <CounterSecOne className="space-bottom" />
        <TeamSecOne className="space bg-smoke overflow-hidden" />
        <TestimonialSecOne className="space-top overflow-hidden bg-auto" />
        <PriceSecOne className="space overflow-hidden" />
        <FaqSecTwo className="space overflow-hidden bg-smoke" />
        <ContactSecOne className="space overflow-hidden" />
        <BlogSecOne className="space-bottom overflow-hidden" />
      </div>
      <Footer />
    </>
  );
};

export default HomeOne;
